// extracted by mini-css-extract-plugin
export var icon = "_s7-0";